// ------------------------------------
// FILTROS
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'products';
    const refEvtPrefix = 'lp-evt-cat-';

    // Elementos
    const $section = $('.catalogo-filtros');

    // Oculta/Exibe os filtros
    function changeFiltersShow() {
      const value = confTheme[ref]['catalog-filters-show'];
      const catWrpGridDesktop = value == '1' ? 'grid-9' : 'grid-12';
      value == '1' ? $section.removeClass('d-none') : $section.addClass('d-none');
      $('.catalogo-content-wrp').removeClass('grid-9 grid-12').addClass(catWrpGridDesktop);
      $root.trigger('lp-evt-populate-catalogos');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'filters-show', changeFiltersShow);

    // Oculta/Exibe os filtros (Categorias)
    function changeFiltersCatsShow() {
      const value = confTheme[ref]['catalog-filters-cats-show'];
      value == '1'
        ? $section.find('.catalogo-filtros-cats').removeClass('d-none')
        : $section.find('.catalogo-filtros-cats').addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'filters-cats-show', changeFiltersCatsShow);

    // Oculta/Exibe os filtros (Preços)
    function changeFiltersPriceShow() {
      const value = confTheme[ref]['catalog-filters-price-show'];
      value == '1'
        ? $section.find('.catalogo-filtros-price').removeClass('d-none')
        : $section.find('.catalogo-filtros-price').addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'filters-price-show', changeFiltersPriceShow);

    // Oculta/Exibe os filtros (Marcas)
    function changeFiltersBrandsShow() {
      const value = confTheme[ref]['catalog-filters-brands-show'];
      value == '1'
        ? $section.find('.catalogo-filtros-brands').removeClass('d-none')
        : $section.find('.catalogo-filtros-brands').addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'filters-brands-show', changeFiltersBrandsShow);
  }
})();

// ------------------------------------
// CATÁLOGO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'products';
    const refEvtPrefix = 'lp-evt-cat-';

    // Altera o grid mobile
    /* function changeGridMobile() {
      const value = confTheme[ref]['catalog-grid-mobile'];
      const gridMobile = value == 1 ? 'grid-sm-12 grid-xs-12' : 'grid-sm-6 grid-xs-6';
      $('.prod-bl-wrp').removeClass('grid-sm-12 grid-xs-12 grid-sm-6 grid-xs-6').addClass(gridMobile);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'grid-mobile', changeGridMobile); */

    // Oculta/Exibe a ordenação
    function changeOrderShow() {
      const value = confTheme[ref]['catalog-order-show'];
      value == '1' ? $('.catalogo-topo-order').removeClass('d-none') : $('.catalogo-topo-order').addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'order-show', changeOrderShow);

    // Altera a ordem padrão
    function changeOrderDefault() {
      const value = confTheme[ref]['catalog-order-default'];
      $('#cat-order').val(value);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'order-default', changeOrderDefault);

    // Oculta/Exibe a visualização
    function changeViewShow() {
      const value = confTheme[ref]['catalog-view-show'];
      value == '1' ? $('.catalogo-topo-view').removeClass('d-none') : $('.catalogo-topo-view').addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'view-show', changeViewShow);
  }
})();

// ------------------------------------
// BANNER
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'products';
    const refEvtPrefix = 'lp-evt-cat-';

    // Exibe título dentro do banner
    function showBannerTit() {
      const value = confTheme[ref]['cat-banner-show-title'];
      if (value == 1) {
        $('.catalogo-topo-tit').addClass('d-none');
        $('.catalogo-topo-banner-content-wrp').removeClass('d-none');
      } else {
        $('.catalogo-topo-tit').removeClass('d-none');
        $('.catalogo-topo-banner-content-wrp').addClass('d-none');
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'banner-show-title', showBannerTit);

    // Altera o alinhamento do título do banner
    function changeTitAlign() {
      const value = confTheme[ref]['cat-banner-align'];
      $('.catalogo-topo-banner-content-wrp, .catalogo-topo-banner-content .title')
        .removeClass('left center')
        .addClass(value);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'banner-align', changeTitAlign);

    // Altera o formato dos banners
    function changeBannerFormat() {
      const value = confTheme[ref]['styles']['cat-banner-radius'];
      $root[0].style.setProperty('--cat-banner-radius', value);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'cat-banner-radius', changeBannerFormat);

    // Altera lista banners
    function changeBannerList() {
      const lastBanner = confTheme[ref]['last-edit-item'] || false;
      if (lastBanner) {
        const bannerTitClass = confTheme[ref]['cat-banner-show-title'] == 1 ? '' : 'd-none';
        const bannerTitAlign = confTheme[ref]['cat-banner-align'] || 'left';
        $('.catalogo-topo-banner').html(`
        <img src="${lastBanner.img}" width="100%" height="200px" alt="${lastBanner.alt}">
        <div class="catalogo-topo-banner-content-wrp ${bannerTitAlign} ${bannerTitClass}">
          <div class="catalogo-topo-banner-content">
            <h1 class="title ${bannerTitAlign}">Produtos</h1>
          </div>
        </div>`);
        $('.catalogo-topo-banner')[0].style.setProperty('--banner-txt-color', lastBanner['banner-txt-color']);
        $('.catalogo-topo-banner')[0].style.setProperty('--banner-overlay', lastBanner['banner-overlay-color']);
        $('.catalogo-topo-banner').removeClass('d-none');
      } else {
        $('.catalogo-topo-banner').addClass('d-none');
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'banner-edit-item', changeBannerList);
  }
})();
